import i18n from 'i18n';

export const CONTENT_TYPE_TEXT_PLAIN = { 'Content-Type': 'text/plain' };

export const KNOWN_RESPONSE_STATUSES = {
  OK: 'OK',
  NOT_FOUND: 'NOT_FOUND',
  BAD_REQUEST: 'BAD_REQUEST',
  INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
};
export const UNKNOWN_RESPONSE_STATUS = 'UNKNOWN_RESPONSE_STATUS';

export const KNOWN_RESPONSE_MESSAGES = {
  ITEM_DISABLED: 'ItemDisabled',
};

export const getItemDisabledErrorMessage = ({
  type,
  code,
}: {
  type: string;
  code: string;
}) =>
  i18n.t('errors.ItemDisabled', {
    ns: 'misc',
    replace: {
      '1': i18n.t(`errors.ItemDisabledTypes.${type}`, { ns: 'misc' }),
      '2': code,
    },
  });
